import 'css-chunk:src/feature/check/CheckTotalEntry.module.scss';export default {
  "balance": "CheckTotalEntry_balance"
};